import { render, staticRenderFns } from "./section-padding.vue?vue&type=template&id=3f754dce&"
import script from "./section-padding.vue?vue&type=script&lang=js&"
export * from "./section-padding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports